import { persistPrismicTokens } from './helpers/prismic'

function onUrlChange (ports) {
  if (ports.onUrlChange) {
    ports.onUrlChange.send(window.location.href)
  }
}

export default function setupPorts (ports) {
  if (ports.onUrlChange) {
    window.addEventListener('popstate', () => { onUrlChange(ports) })
  }

  if (ports.pushUrl) {
    ports.pushUrl.subscribe((newUrl) => {
      window.history.pushState({}, '', persistPrismicTokens(newUrl))
    })
  }

  if (ports.newUrl) {
    ports.newUrl.subscribe((newUrl) => {
      window.history.pushState({}, '', persistPrismicTokens(newUrl))
      onUrlChange(ports)
    })
  }

  if (ports.modifyUrl) {
    ports.modifyUrl.subscribe((newUrl) => {
      window.history.replaceState({}, '', persistPrismicTokens(newUrl))
      onUrlChange(ports)
    })
  }

  if (ports.replaceUrl) {
    ports.replaceUrl.subscribe((newUrl) => {
      window.history.replaceState({}, '', persistPrismicTokens(newUrl))
    })
  }

  if (ports.load) {
    ports.load.subscribe((newUrl) => {
      window.location.href = newUrl
    })
  }

  if (ports.back) {
    ports.back.subscribe(() => window.history.back())
  }
}
